import React, { useEffect, useState } from 'react';
import { Input } from '../../../ui/input';

/** Целое в границах или null для пустого ввода. */
export function parseBounded(raw, min, max) {
  const text = String(raw ?? '').trim();
  if (text === '') return null;
  const n = Math.floor(Number(text));
  if (!Number.isFinite(n)) return null;
  return Math.min(Math.max(n, min), max);
}

/** Числовое поле с черновиком: запрос уходит по Enter/потере фокуса, а не на каждую цифру. */
export function CommitInput({ value, onCommit, placeholder, min, max, className, fallback = null }) {
  const [draft, setDraft] = useState(value ?? '');
  useEffect(() => setDraft(value ?? ''), [value]);
  // Черновик сразу приводим к применённому значению: если оно совпало с
  // прежним, эффект по value не сработает и в поле осталось бы «5000» при 1000.
  const commit = () => {
    const next = parseBounded(draft, min, max);
    setDraft(next ?? (fallback ?? ''));
    onCommit(next);
  };
  return (
    <Input
      type="number"
      className={className}
      min={min}
      max={max}
      placeholder={placeholder}
      value={draft}
      onChange={(e) => setDraft(e.target.value)}
      onBlur={commit}
      onKeyDown={(e) => e.key === 'Enter' && commit()}
    />
  );
}
